var _path, _polygon, _polygon2, _polygon3, _polygon4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "16px",
    viewBox: "0 0 13 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.846,0.41 C8.74424052,0.206168479 8.53582028,0.0775522739 8.308,0.0779976757 L4.49,0.0779976757 C4.26217972,0.0775522739 4.05375948,0.206168479 3.952,0.41 L3.064,2.2 L0.038,2.2 L0.038,3.4 L0.892,3.4 L0.892,15.322 C0.892,15.6533708 1.16062915,15.922 1.492,15.922 L11.308,15.922 C11.6393708,15.922 11.908,15.6533708 11.908,15.322 L11.908,3.4 L12.762,3.4 L12.762,2.2 L9.736,2.2 L8.846,0.41 Z",
    fill: "#848484",
    fillRule: "nonzero"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "4.862 1.278 7.938 1.278 8.4 2.2 4.4 2.2"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "4.446 13.4 3.246 13.4 3.246 5.14 4.446 5.14"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "7 13.4 5.8 13.4 5.8 5.14 7 5.14"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "9.554 13.4 8.354 13.4 8.354 5.14 9.554 5.14"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleted);
export default __webpack_public_path__ + "static/media/deleted.a5a51a1903763b036d27b3c3e843496d.svg";
export { ForwardRef as ReactComponent };